import { PLAYER_COLORS } from '@sheepocalypse/shared';

const COLOR_LABELS: Record<string, string> = {
  '#ef4444': 'Red',
  '#3b82f6': 'Blue',
  '#22c55e': 'Green',
  '#eab308': 'Yellow',
  '#a855f7': 'Purple',
  '#ec4899': 'Pink',
  '#f97316': 'Orange',
  '#06b6d4': 'Cyan',
};

export const PLAYER_COLOR_OPTIONS = PLAYER_COLORS.map(color => ({
  value: color,
  label: COLOR_LABELS[color] ?? color,
}));

export function getPlayerColorLabel(color: string): string {
  return COLOR_LABELS[color] ?? color;
}
